import base from './base';

const darkTheme = {
  primary: '#fff',
  'primary-hover': '#ffffffaf',
  secondary: '#000',
  'secondary-hover': '#0000006e',
  'app-color': '#7284FF',

  'text-color': '#fff',
  'text-color-hover': '#fff',
  'text-color-light': '#ffffff96',
  'text-color-xlight': 'rgba(255, 255, 255, 0.425)',
  'text-color-xxlight': 'rgba(255, 255, 255, 0.3)',

  'text-contrast': '#000',

  'bg-color': '#111',
  'bg-color-card': 'rgba(255, 255, 255, 0.1019607843)',
  'review-card-bg-color': '#222',

  'box-shadow-color': 'rgba(0, 0, 0, 0.75)',
  'border-color': '',

  'user-navigation-bottom-border': '#222',

  'not-eligible-text-color': 'rgb(231, 231, 231,0.5)',
  'bottomBar-bg': '#7284FF',

  'search-bar-container-bg': '#222',
  'search-result-bg': '#222',
  'search-bar-logo-bg': '#444',
  'input-bg-color': '#333',
  'input-border-color': 'transparent',

  expandable_category_wrapper_bg: '#333',

  'dropdown-color': '#fff',
  'dropdown-bg-color': '#7284FF',

  'filter-dropdown-bg': '#333',

  'text-editor-box-shadow':'transparent',

  'button-bg-color': '#161612',
  'button-bg-color-hover': '#2f2f28',
  'button-bg-color-dark': '#2e2e2e',
  'button-bg-color-dark-hover': '#2e2e2eb6',

  'like-bg-color': 'rgba(21, 156, 74, 0.2)',
  'dislike-bg-color': 'rgba(199, 41, 41, 0.2)',

  'protocol-bg': '#7284FF',
  'protocol-text-color': '#E7EAFF',

  'table-container-border': 'tranparent',
  'table-container-bg': 'rgba(51, 51, 51, 1)',
  'table-container-row-bg': 'rgba(34, 34, 34, 1)',

  'project-review-bg': 'rgba(34, 34, 34, 1)',

  'color-supertake-text': 'rgba(17, 17, 17, 1)',

  'project-selected-bg': '#444',

  'dropdown-hover-color': 'rgba(255, 255, 255, 0.1019607843)',

  'negative-text-color': '#111',

  'alert-color': 'red',
  'alert-color-hover': 'rgb(179, 0, 0)',
  'success-color': 'rgb(20, 227, 20)',

  'skeleton-base-color': '#2c2c2c',
  'skeleton-highlight-color': '#3a3a3a',

  'toggle-bg-color': '#c0c0c0',
  'navbar-tab-bg': 'rgba(255, 255, 255, 0.1019607843)',
  'reaction-bg': '#333',
  'reaction-border-like': '',
  'reaction-border-dislike': '',
  'like-fill-color': 'rgba(152, 229, 108, 0.50)',
  'dislike-fill-color': 'rgba(255, 88, 88, 0.50)',

  ...base,
};
export default darkTheme;
